
(function roleFindControllerDefinition() {
    'use strict';

    angular.module('Role')
        .controller('RoleFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'adminRoleService', 'authExtend', '$stateParams', 'functionService', 'fileDownloader', '$filter',
            function roleFindController($scope, config, $state, $translate, errors, adminRoleService, authExtend, $stateParams, functionService, fileDownloader, $filter) {

                $scope.findAction = function () {

                    $scope.find.showNoData = false;
                    adminRoleService.setFilter($scope.find);

                    return adminRoleService.get(
                        $scope.find.Name,
                        $scope.find.organizationalUnitId,
                        undefined,
                        $scope.find.applicationId ? $scope.find.applicationId.id : undefined,
                        $scope.data.currentPage,
                        $scope.data.itemsPerPage
                    ).then(function getOk(result) {
                        console.log(result);
                        $scope.roles = result.value;
                        $scope.data.totalItems = result.totalCount;
                        $scope.data.from = 1 + ($scope.data.itemsPerPage * ($scope.data.currentPage - 1));
                        if ($scope.roles.length === 0)
                            $scope.find.showNoData = true;

                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.load = function () {
                    $scope.hideAddBtn = !authExtend.isInRole('ROLE WRITE');
                    $scope.allApps = authExtend.isInRole('CONFIG ADMIN APPS');
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0
                    };
                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };
                        });

                    if ($scope.allApps) {
                        functionService.getApps().then(function getOk(result) {
                            $scope.optionApps = result;
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }

                    $scope.find = adminRoleService.getFilter();
                    $scope.organizationalUnitId = authExtend.getOrganizationId();
                    $scope.roles = [];

                    $scope.findAction();
                }

                $scope.export = function () {
                    adminRoleService.export($scope.find.Name, $scope.find.organizationalUnitId, undefined, $scope.find.applicationId ? $scope.find.applicationId.id : undefined).then(function getOk(result) {
                        var d = new Date();
                        var d = new Date();
                        var month = d.getUTCMonth() + 1;

                        var success = fileDownloader.saveAs(result.value, 'Listado de Roles - Funciones ' +
                            d.getUTCFullYear() +
                            ("00".substring(0, 2 - (month + '').length) + month) +
                            ("00".substring(0, 2 - (d.getDate() + '').length) + d.getDate()) +
                            '.xlsx');
                        if (!success) {
                            errors.showError('Api failed');
                        }
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.modify = function (role) {
                    $state.go('role-modify', { id: role.id });
                };

                $scope.clone = function (role) {
                    $state.go('role-clone', { id: role.id });
                };

                $scope.add = function () {
                    $state.go('role-add');
                };

                $scope.view = function (role) {
                    $state.go('role-detail', { id: role.id });
                };

                $scope.functions = function (role) {
                    $state.go('role-functions', { id: role.id });
                };

                $scope.documentTypes = function (role) {
                    $state.go('role-document-types', { id: role.id, name: role.name });
                };

                $scope.containerTypes = function (role) {
                    $state.go('role-container-types', { id: role.id, name: role.name });
                }

                $scope.states = function (role) {
                    $state.go('role-states', { id: role.id });
                };

                $scope.load();
            }
        ]);
})();